import React from "react";
import { BrowserRouter } from "react-router-dom";
import { AppProviders } from "./app/providers/AppProviders";
import { AppRoutes } from "./app/routes";
import './App.css';


const App = () => {
  return (
    <AppProviders>
      <BrowserRouter>
        <div className="app-shell">
          <div className="app-content">
            <AppRoutes />
          </div>
          <footer className="app-footer">
            © 2026 CaseFlow. A product of NineBit Computing Pvt. Ltd.
          </footer>
        </div>
      </BrowserRouter>
    </AppProviders>
  );
};

export default App;
